/* global mixpanel */
import moment from 'moment'

export function customerFeedbackStart () {
  mixpanel.track('Feedback Start')
}

export function customerFeedbackReply ({feedback}) {
  mixpanel.track('Feedback Reply', {
    'Type': feedback.feedback_from
  })
}

export function customerFeedbackSelect ({feedback, transaction, feedbackMessages}) {
  let lastCustomerMessage = ''
  let lastMerchatMessage = ''
  for (let i = feedbackMessages.messages.length - 1; i >= 0 && (!lastCustomerMessage || !lastMerchatMessage); i--) {
    if (feedbackMessages.messages[i].is_customer && !lastCustomerMessage) {
      lastCustomerMessage = feedbackMessages.messages[i].comment
    } else if (!feedbackMessages.messages[i].is_customer && !lastMerchatMessage) {
      lastMerchatMessage = feedbackMessages.messages[i].comment
    }
  }
  mixpanel.track('Feedback List Select', {
    'Feedback Date': feedback.feedback_date,
    'Feedback Message Type': feedback.feedback_type,
    'Feedback Last Customer Message': lastCustomerMessage,
    'Feedback Last Merchant Message': lastMerchatMessage,
    'Transaction Date': moment(transaction.created_at).format('YYYY-MM-DD'),
    'Transaction Time': moment(transaction.created_at).format('hh:mm:ss'),
    'Receipt Number': transaction.payment_no,
    'Served By': transaction.served_by,
    'Collected By': transaction.collected_by,
    'Total': transaction.total_collected,
    'Payment Method': transaction.payment_type,
    'Payment Amount': transaction.tendered,
    'Change': transaction.change,
    'Payment Note': transaction.payment_note
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/customers/feedback.js